import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

// Each move places question `id` next to one sibling. Supply exactly one of
// `afterId` / `beforeId` — the server rejects both together. Moving to the
// front has no predecessor to sit after, so it uses `beforeId`.
export interface CBQQuestionMove {
  id: string;
  afterId?: string | null;
  beforeId?: string | null;
}

type ReorderCBQQuestionsResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: unknown;
};

export const ReorderCBQQuestions = async (
  scenarioId: string,
  moves: CBQQuestionMove[]
): Promise<ReorderCBQQuestionsResponse> => {
  try {
    const response = await axios.post(
      `/admin/cbq/scenarios/${scenarioId}/questions/reorder`,
      { moves }
    );
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
